import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

export function useSubscriptionCheck() {
  const { user } = useAuth();
  const [subscriptionData, setSubscriptionData] = useState({
    isActive: false,
    isExpired: false,
    isExpiringSoon: false,
    daysRemaining: 0,
    subscription: null,
    loading: true
  });

  useEffect(() => {

    if (!user?.id) {
      setSubscriptionData({
        isActive: false,
        isExpired: false,
        isExpiringSoon: false,
        daysRemaining: 0,
        subscription: null,
        loading: false
      });
      return;
    }

    checkSubscription();
  }, [user?.id]);

  const checkSubscription = async () => {
    try {

      // Get psychologist profile
      const { data: psychologist, error: psychError } = await supabase
        ?.from('psychologists')
        ?.select('id')
        ?.eq('user_id', user?.id)
        ?.single();

      if (psychError || !psychologist) {

        setSubscriptionData({
          isActive: false,
          isExpired: false,
          isExpiringSoon: false,
          daysRemaining: 0,
          subscription: null,
          loading: false
        });
        return;
      }

      // Check if subscription is active
      const { data: isActive } = await supabase
        ?.rpc('is_subscription_active', {
          p_psychologist_id: psychologist?.id
        });

      // Get days remaining
      const { data: daysRemaining } = await supabase
        ?.rpc('get_subscription_days_remaining', {
          p_psychologist_id: psychologist?.id
        });

      // Get subscription details
      const { data: subscription } = await supabase
        ?.from('subscriptions')
        ?.select('*')
        ?.eq('psychologist_id', psychologist?.id)
        ?.order('created_at', { ascending: false })
        ?.limit(1)
        ?.single();

      const remainingDays = daysRemaining || 0;
      const isExpired = !isActive;
      const isExpiringSoon = isActive && remainingDays <= 3 && remainingDays > 0;

      setSubscriptionData({
        isActive: isActive || false,
        isExpired,
        isExpiringSoon,
        daysRemaining: remainingDays,
        subscription,
        loading: false
      });
    } catch (error) {
      console.error('Error checking subscription:', error);
      setSubscriptionData({
        isActive: false,
        isExpired: false,
        isExpiringSoon: false,
        daysRemaining: 0,
        subscription: null,
        loading: false
      });
    }
  };

  return {
    ...subscriptionData,
    refetch: checkSubscription
  };
}